export { SubjectComponent } from './subject.component';
export { WelcomeComponent } from './welcome/welcome.component';
